<template>
  <div class="edit-tabs" v-if="tabsHaveTitles">
    <ul>
      <li v-for="tab in tabs" :class="{active: activeTab==tab.id}">
        <a href="" @click.prevent="$emit('update:activeTab', tab.id)">{{tab.title}}</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    tabs: {},
    activeTab: {},
  },
  computed: {
    tabsHaveTitles() {
      return !!(this.tabs || []).map(item=>item.title).join("");
    },
  },
}
</script>
